<template>
  <b-card header="Editar Translado">
    <b-form @submit.prevent="send()">
      <b-row class="form-group">
        <label class="col-sm-2 col-form-label">Línea naviera</label>
        <div class="col-sm-5">
          <v-select
            v-model="shipping_line"
            :value="service.shipping_line_id"
            :options="shipping_lines"
            label="name"
            :on-change="setShippingLine"
          ></v-select>
        </div>
      </b-row>
      <b-row class="form-group">
        <label class="col-sm-2 col-form-label">Nave</label>
        <div class="col-sm-5">
          <input type="text" v-model="service.ship_name" required class="form-control" />
        </div>
      </b-row>
      <b-row class="form-group">
        <label class="col-sm-2 col-form-label">CUTOFF</label>
        <div class="col-sm-5">
          <date-picker
            v-model="service.cutoff"
            lang="es"
            type="datetime"
            format="DD/MM/YYYY HH:mm"
            :time-picker-options="{ start: '00:00', step: '00:30', end: '23:55' }"
          ></date-picker>
        </div>
      </b-row>
      <b-row class="form-group">
        <label class="col-sm-2 col-form-label">Booking</label>
        <div class="col-sm-5">
          <input type="text" v-model="service.doc_number" class="form-control" />
        </div>
      </b-row>
      <b-row class="form-group">
        <label class="col-sm-2 col-form-label">Embarcador</label>
        <div class="col-sm-5">
          <input type="text" v-model="service.owner_name" required class="form-control" />
        </div>
      </b-row>

      <b-row class="form-group">
        <label
          class="col-sm-2 col-form-label"
        >{{service.service_type.code === constants.POSICIONAMIENTOS ? 'Fecha de retiro en Depot' : 'Fecha y horario de entrega'}}</label>
        <div class="col-sm-5">
          <date-picker
            v-model="rq.date"
            lang="es"
            type="datetime"
            required
            format="DD/MM/YYYY HH:mm"
            :time-picker-options="{ start: '00:00', step: '00:30', end: '23:55' }"
          ></date-picker>
        </div>
      </b-row>

      <b-row class="form-group" v-if="service.service_type.code === constants.POSICIONAMIENTOS">
        <label class="col-sm-2 col-form-label">Fecha de llenado</label>
        <div class="col-sm-5">
          <date-picker
            v-model="rq.date_fill"
            lang="es"
            type="datetime"
            required
            format="DD/MM/YYYY HH:mm"
            :time-picker-options="{ start: '00:00', step: '00:30', end: '23:55' }"
          ></date-picker>
        </div>
      </b-row>

      <b-row class="form-group">
        <label class="col-sm-2 col-form-label">Carta de precinto</label>
        <div class="col-sm-5">
          <input type="file" ref="letter" @change="previewLetter" />
        </div>
      </b-row>
      <b-row class="form-group">
        <label class="col-sm-2 col-form-label">Booking</label>
        <div class="col-sm-5">
          <input type="file" ref="booking" @change="previewBooking" />
        </div>
      </b-row>
      <div slot="footer">
        <input type="submit" class="btn btn-primary" value="Enviar" />
      </div>
    </b-form>
  </b-card>
</template>

<script>
import api from "@/helpers/api";
import VueTagsInput from "@johmun/vue-tags-input";
import moment from "moment";
import constants from "@/constants";

export default {
  components: { VueTagsInput },
  data() {
    return {
      id: this.$route.params.id,
      service: {
        service_type: {}
      },
      rq: {},
      constants,
      doc_seal: null,
      doc_booking: null,
      shipping_lines: [],
      shipping_line: {},
      text: ""
    };
  },
  mounted() {
    if (this.id) {
      api.get(`/service/${this.id}`).then(({ service, requeriments }) => {
        this.service = service;
        this.rq = requeriments.length ? requeriments[0] : {};
        this.shipping_line = this.service.shipping_line;
      });
    }

    api.get("/shipping_lines").then(response => {
      this.shipping_lines = response.shipping_lines;
    });
  },
  methods: {
    setShippingLine(obj) {
      this.shipping_line = obj ? obj : {};
      this.service.shipping_line_id = obj ? obj.id : null;
    },
    previewLetter() {
      this.doc_seal = this.$refs.letter.files[0];
    },
    previewBooking() {
      this.doc_booking = this.$refs.booking.files[0];
    },
    validations() {
      let result = true;

      if (!this.service.shipping_line_id) {
        this.$toastr.warning(
          "Debes indicar linea naviera",
          "Traslado de vacíos",
          {
            positionClass: "toast-top-center",
            closeButton: true
          }
        );
        result = false;
      }

      if (!this.service.cutoff || !moment(this.service.cutoff).isValid()) {
        this.$toastr.warning("Fecha cutoff inválida", "Traslado de vacíos", {
          positionClass: "toast-top-center",
          closeButton: true
        });
        result = false;
      }

      return result;
    },
    send() {
      const { service, doc_seal, doc_booking } = this;
      let formData = new FormData();

      if (this.validations()) {
        if (doc_seal) formData.append("doc_seal", doc_seal);
        if (doc_booking) formData.append("doc_booking", doc_booking);

        const data = {
          cutoff: moment(service.cutoff).format("YYYY-MM-DD HH:mm:ss"),
          shipping_line_id: service.shipping_line_id,
          ship_name: service.ship_name,
          doc_number: service.doc_number,
          owner_name: service.owner_name,
          rq: {
            date: moment(this.rq.date).format('YYYY-MM-DD HH:mm:ss'),
            date_fill: moment(this.rq.date_fill).format('YYYY-MM-DD HH:mm:ss'),
          }
        };
        formData.append("service", JSON.stringify(data));

        api
          .put(`/void/${this.id}`, formData, {
            headers: { "Content-Type": "multiplart/form-data" }
          })
          .then(response => {
            this.$toastr.success(
              "Registrado exitosamente",
              "Traslado de vacíos",
              {
                positionClass: "toast-top-center",
                closeButton: true
              }
            );
          });
      }
    }
  }
};
</script>
